export enum IFrameLoadingType {
    EAGER = "eager",
    LAZY = "lazy"
}
